import CreateWorkspace from './CreateWorkspace';

export default CreateWorkspace;
